import http from '@/communication/AuthConnection'

export default async ({ commit }, { mergeWith }) => {
  try {
    const request = await http.get('/v1/bid-mirror/list-all')

    let bidMirror = []
    if (request.data && request.data.list) {
      bidMirror = addInputValue({
        data: request.data.list,
        mergeWith
      })
    }
    return {
      list: bidMirror
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

const addInputValue = ({ data, mergeWith }) => {
  for (let category in data) {
    let requirementList = data[category].requirement
    for (let requirementDetails in requirementList) {
      let reqDetails = requirementList[requirementDetails].requirementDetail
      const mergeReqValue = mergeWith.find(item => item.requirementId.toString() === requirementList[requirementDetails]._id.toString())
      const reqInputValue = mergeReqValue && mergeReqValue.inputValue
      requirementList[requirementDetails].inputValue = reqInputValue || ''
      // requirementList[requirementDetails].checked = !!reqInputValue

      if (reqDetails) {
        for (let requirementDetail in reqDetails) {
          let reqDetail = reqDetails[requirementDetail]
          const mergeReqDetailsValue = mergeWith.find(item => item.requirementId.toString() === reqDetail._id.toString())
          const reqDetailInputValue = mergeReqDetailsValue && mergeReqDetailsValue.inputValue

          reqDetail.inputValue = reqDetailInputValue || ''

          // reqDetail.checked = !!reqDetailInputValue
        }
      }
    }
  }

  return data
}



// WEBPACK FOOTER //
// ./src/brain/bid-mirror/ListBidMirrors.js